<template>
  <div class="video-item">
    <div
      class="video-preview"
      :style="previewbg"
    >
      <div class="icon-play" @click="$emit('show')"></div>
    </div>
    <div class="video-caption">
      <h3>{{videoData.title | vtitle}}</h3>
      <div class="control" v-if="backstage">
        <div v-if="videoData.behind" class="btn-backstage" @click="$emit('showbehind')">幕后</div>
        <div class="spacer"></div>
        <div v-if="videoData.out_link" class="btn-outlink"></div>
      </div>
      <div class="btn-outlink title-right" v-else></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    videoData: Object,
    backstage: Boolean
  },
  data() {
    return {};
  },
  computed: {
    previewbg() {
      const src = this.videoData.preview ? this.videoData.preview : "img/video-default-bg.jpg";
      return {
        backgroundImage: `url(${src})`
      };
    }
  },
  filters: {
    vtitle(value) {
      return value.length > 6 ? value.slice(0, 6) + "..." : value;
    }
  },
  methods: {
    showContent(data) {
      this.$emit("");
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.video-item {
  width: 49%;
  margin-bottom: 0.5rem;

  .video-preview {
    position: relative;
    height: 25vw;
    overflow: hidden;
    background-position-y: center;
    background-size: 100%;
    @include img-fluid;

    .icon-play {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      width: 2.5rem;
      height: 2.5rem;
      border: 1px solid #fff;
      background-color: rgba(255, 255, 255, 0.4);
      border-radius: 100%;
    }

    .icon-play:after {
      content: "";
      position: relative;
      left: 50%;
      margin-left: -0.125rem;
      @include center-y;
      display: block;
      width: 0px;
      height: 0px;
      border: 0.5rem transparent solid;
      border-left-color: #fff;
    }
  }

  .video-caption {
    position: relative;
    padding: 0.5rem;
    background-color: #f7f1da;
    white-space: nowrap;
    overflow: hidden;

    @include title-h3(0.875rem);
    h3 {
      margin: 0;
      height: 1.05rem;
      padding: 0 0.5rem;
      line-height: 1.2;

      &::before,
      &::after {
        height: 1.05rem;
      }

      &::before {
        background-image: url("~@/assets/img/video/title-left.png");
      }

      &::after {
        background-image: url("~@/assets/img/video/title-right.png");
      }
    }

    .control {
      display: flex;
      height: 1.75rem;
      margin: 0;

      .btn-backstage {
        font-size: 0.875rem;
        line-height: 2;
        text-decoration: underline;
      }

      .spacer {
        flex: 1;
      }
    }

    .btn-outlink {
      width: 1.25rem;
      height: 1.25rem;
      background-image: url("~@/assets/img/video/icon-outlink.png");
      background-repeat: no-repeat;
      background-size: 100%;
    }

    .title-right {
      position: absolute;
      right: 0.5rem;
      top: 0.65rem;
    }
  }
}
</style>
